var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { memo, useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import withSDK from '../../../core/hocs/withSDK';
import useUser from '../../../core/hooks/useUser';
import { useNavigation } from '../../../social/providers/NavigationProvider';
import UIUserInfo from './UIUserInfo';
import useFollow from '../../../core/hooks/useFollow';
import useFollowCount from '../../../core/hooks/useFollowCount';
import useImage from '../../../core/hooks/useImage';
import { useAsyncCallback } from '../../../core/hooks/useAsyncCallback';
import { notification } from '../../../core/components/Notification';
import { UserFeedTabs } from '../../../social/pages/UserFeed/constants';
const UserInfo = ({ userId, currentUserId, setFollowActiveTab, setActiveTab, isPrivateNetwork, showUserProfileMetadata, }) => {
    const { formatMessage } = useIntl();
    const { onEditUser, onMessageUser } = useNavigation();
    const { user, file } = useUser(userId);
    const { follow, followDecline, isFollowPending, isFollowNone, isFollowAccepted } = useFollow(currentUserId, userId);
    const { followerCount, followingCount } = useFollowCount(userId);
    const { displayName, description } = user;
    const { fileId } = file;
    const fileUrl = useImage({ fileId });
    const [onFollowDecline] = useAsyncCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield followDecline();
        setActiveTab(UserFeedTabs.TIMELINE);
        notification.success({ content: React.createElement(FormattedMessage, { id: "notification.done" }) });
    }), [followDecline]);
    return (React.createElement(UIUserInfo, { userId: userId, currentUserId: currentUserId, fileUrl: fileUrl, displayName: displayName || formatMessage({ id: 'anonymous' }), description: description, setActiveTab: setActiveTab, setFollowActiveTab: setFollowActiveTab, isMyProfile: userId === currentUserId, isFollowPending: isFollowPending, isPrivateNetwork: isPrivateNetwork, isFollowNone: isFollowNone, isFollowAccepted: isFollowAccepted, followerCount: followerCount, followingCount: followingCount, onFollowRequest: follow, onFollowDecline: onFollowDecline, onEditUser: onEditUser, onMessageUser: onMessageUser, showUserProfileMetadata: showUserProfileMetadata }));
};
UserInfo.propTypes = {
    userId: PropTypes.string.isRequired,
    currentUserId: PropTypes.string.isRequired,
    setActiveTab: PropTypes.func,
    setFollowActiveTab: PropTypes.func,
    isPrivateNetwork: PropTypes.bool.isRequired,
};
export { UIUserInfo };
export default memo(withSDK(UserInfo));
//# sourceMappingURL=index.js.map